import Layout from "./Layout.jsx";
import Museum from "./Museum";
import Fleet from "./Fleet";
import WorldMap from "./WorldMap";
import Home from "./Home";
import IntroCinematic from "./IntroCinematic";
import CreateAirlineWizard from "./CreateAirlineWizard";
import VideoIntro from "./VideoIntro";
import MainMenu from "./MainMenu";
import Start from "./Start";
import FlightDebug from "./FlightDebug";
import OpsCenter from "./OpsCenter";
import AircraftMarket from "./AircraftMarket";
import RoutesPage from "./Routes";
import SimpleRoutes from "./SimpleRoutes";
// Preflight archived - simulation mode only
import FinancialsPage from "./Financials";
import LiveryDesigner from "./LiveryDesigner";
import ModeSelection from "./ModeSelection";
import Airports from "./Airports";
import EOSStore from "./EOSStore";
import Inbox from "./Inbox";
import KnowledgeBase from "./KnowledgeBase";
import HubStore from "./HubStore";
import Leaderboard from "./Leaderboard";
import CashStore from "./CashStore";
import Fuel from "./Fuel";
import IntroSequence from "./IntroSequence";
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';

// Root redirect - handles onboarding flow
// All players start at MainMenu
// MainMenu handles: New Game -> mode-select, Continue -> OpsCenter
function RootRedirect() {
    return <Navigate to="/MainMenu" replace />;
}

const PAGES = {
    OpsCenter: OpsCenter,
    WorldMap: WorldMap,
    Fleet: Fleet,
    AircraftMarket: AircraftMarket,
    Routes: RoutesPage,
    SimpleRoutes: SimpleRoutes,
    // Preflight archived - simulation mode only
    Museum: Museum,
    Inbox: Inbox,
    Home: Home,
    IntroCinematic: IntroCinematic,
    CreateAirlineWizard: CreateAirlineWizard,
    VideoIntro: VideoIntro,
    MainMenu: MainMenu,
    Start: Start,
    FlightDebug: FlightDebug,
    LiveryDesigner: LiveryDesigner,
    ModeSelection: ModeSelection,
    Airports: Airports,
    EOSStore: EOSStore,
    KnowledgeBase: KnowledgeBase,
    HubStore: HubStore,
    Leaderboard: Leaderboard,
    CashStore: CashStore,
}

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }
    let urlLastPart = url.split('/').pop();
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }
    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || Object.keys(PAGES)[0];
}

function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    return (
        <Layout currentPageName={currentPage}>
            <Routes>
                <Route path="/" element={<RootRedirect />} />
                <Route path="/Museum" element={<Museum />} />
                <Route path="/Inbox" element={<Inbox />} />
                <Route path="/Fleet" element={<Fleet />} />
                <Route path="/WorldMap" element={<WorldMap />} />
                <Route path="/Home" element={<Home />} />
                <Route path="/IntroCinematic" element={<IntroCinematic />} />
                <Route path="/CreateAirlineWizard" element={<CreateAirlineWizard />} />
                <Route path="/VideoIntro" element={<VideoIntro />} />
                <Route path="/MainMenu" element={<MainMenu />} />
                <Route path="/Start" element={<Start />} />
                <Route path="/FlightDebug" element={<FlightDebug />} />
                <Route path="/OpsCenter" element={<OpsCenter />} />
                <Route path="/AircraftMarket" element={<AircraftMarket />} />
                <Route path="/routes" element={<RoutesPage />} />
                <Route path="/simple-routes" element={<SimpleRoutes />} />
                {/* Preflight archived - redirect to ops center */}
                <Route path="/Preflight" element={<Navigate to="/OpsCenter" replace />} />
                <Route path="/financials" element={<FinancialsPage />} />
                <Route path="/livery" element={<LiveryDesigner />} />
                <Route path="/intro" element={<IntroSequence />} />
                <Route path="/mode-select" element={<ModeSelection />} />
                <Route path="/airports" element={<Airports />} />
                <Route path="/eos-store" element={<EOSStore />} />
                <Route path="/knowledge-base" element={<KnowledgeBase />} />
                <Route path="/hub-store" element={<HubStore />} />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="/cash-store" element={<CashStore />} />
                <Route path="/fuel" element={<Fuel />} />
            </Routes>
        </Layout>
    );
}

export default function Pages() {
    return (
        <Router>
            <PagesContent />
        </Router>
    );
}